/**
 * Print support for the free tools' records (excavation selector, scaffold
 * inspection due-date tool). The record is an ordinary element inside the
 * tool's private region; when the visitor prints, this stylesheet removes
 * everything except the record and its ancestors from the layout (so the
 * rest of the page cannot add trailing blank pages) and hides the ancestors'
 * own content, so the printout is the record alone. Every print rule is
 * scoped to a page that actually has the record, so printing before there is
 * a result prints the page as normal instead of a blank sheet. Nothing is generated
 * on a server and nothing leaves the browser: the visitor's own print dialog
 * makes the paper or PDF copy.
 */
export function PrintRecordStyle({ recordId }: { recordId: string }) {
  const css = `@media screen{#${recordId}{display:none}}
@media print{body:has(#${recordId}) *:not(:has(#${recordId})):not(#${recordId}):not(#${recordId} *){display:none!important}
body:has(#${recordId}) *{visibility:hidden}#${recordId},#${recordId} *{visibility:visible}
#${recordId}{display:block;position:absolute;left:0;top:0;width:100%;color:black;background:white}
#${recordId} li,#${recordId} tr{break-inside:avoid}@page{size:A4;margin:16mm}}`;
  return <style>{css}</style>;
}

export const PRINT_BUTTON_CLASS =
  "inline-flex min-h-[44px] items-center justify-center rounded-lg bg-accent px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-accent-dark";
